import type { ConfigContext } from "@shared/schemas/config-context.schemas";

function serializeConfigContext(context: ConfigContext): string {
  const entries = Object.entries(context).filter(
    ([, value]) => value !== null && value !== undefined,
  );
  entries.sort(([a], [b]) => a.localeCompare(b));
  return JSON.stringify(Object.fromEntries(entries));
}

export const FEATURE_CONFIG_QUERY_KEYS = {
  all: ["feature-configs"] as const,

  resolveList: (context: ConfigContext) =>
    ["feature-configs", "resolved", serializeConfigContext(context)] as const,

  resolveByKey: (featureKey: string, context: ConfigContext) =>
    [
      "feature-configs",
      "resolved",
      featureKey,
      serializeConfigContext(context),
    ] as const,
} as const;
